import {
  DEEP_LINK_NOMINATE_VALUE,
  DEEP_LINK_SESSION_KEY,
} from "AppComponents/AITutorAwards/modules/Constants";

const setIntent = () => {
  try {
    sessionStorage.setItem(
      DEEP_LINK_SESSION_KEY,
      JSON.stringify({ v: DEEP_LINK_NOMINATE_VALUE, t: Date.now() })
    );
  } catch {
    // best-effort
  }
};

export default () => ({
  path: "ai-tutor-awards-nominate",
  onEnter: (nextState, replace) => {
    const { search = "", hash = "" } = nextState.location || {};
    setIntent();
    replace({ pathname: "/", search, hash });
  },
});
